import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';

const NavItem = ({ to, icon, label }) => (
    <Link to={to} className="nav-item">
        <div className="icon">{icon}</div>
        <p>{label}</p>
    </Link>
);

export default function Main() {
    const { user } = useAuth();

    return (
        <Layout>
            <div className="nav-container">
                <NavItem to="/student/reading-registration" icon="📖" label="독서 등록" />
                <NavItem to="/student/reading-log" icon="📚" label="독서 기록" />
                <NavItem to="/student/status-board" icon="📊" label="독서 현황판" />
                {user?.is_teacher && (
                    <NavItem to="/teacher" icon="👩‍🏫" label="선생님 페이지" />
                )}
            </div>
        </Layout>
    );
}

